export default __webpack_public_path__ + "hoveranimation_poster.png";